module.exports = __webpack_public_path__ + "static/media/whiteArrow.4a64fa5d.svg";